import MedicalAppointments from './MedicalAppointments';

export default MedicalAppointments;
